import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../lib/api.js";

export function PostsView() {
  const { data } = useQuery({ queryKey: ["posts"], queryFn: api.posts, refetchInterval: 10_000 });
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <div>
      <h1>Posts</h1>
      {data?.items.length === 0 && <p className="muted">Nothing scheduled yet.</p>}
      {data?.items.map((p) => (
        <div key={p.id} className="card">
          <div className="row" style={{ justifyContent: "space-between" }}>
            <div onClick={() => setOpenId(openId === p.id ? null : p.id)} style={{ cursor: "pointer", flex: 1 }}>
              <strong>{p.caption.slice(0, 80) || "(no caption)"}</strong>
              <div className="muted">
                <span className="badge">{p.status}</span>{" "}
                {p.scheduledAt ? new Date(p.scheduledAt).toLocaleString() : "draft"}
              </div>
            </div>
            {["scheduled", "publishing", "draft"].includes(p.status) && (
              <button onClick={() => api.cancelPost(p.id).then(() => location.reload())}>Cancel</button>
            )}
          </div>
          {openId === p.id && <PostDetail id={p.id} />}
        </div>
      ))}
    </div>
  );
}

function PostDetail({ id }: { id: string }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["post", id], queryFn: () => api.post(id), refetchInterval: 5_000 });
  if (!data) return <p className="muted">Loading…</p>;
  return (
    <div style={{ marginTop: "0.8rem" }}>
      {data.targets.map((t) => (
        <div key={t.id} className="row" style={{ justifyContent: "space-between", padding: "0.3rem 0" }}>
          <span>
            <span className="badge">{t.platform}</span> {t.connectionName} — {t.status}
            {t.lastError ? <span className="muted"> · {t.lastError}</span> : null}
          </span>
          <span className="row">
            {t.permalink && (
              <a href={t.permalink} target="_blank" rel="noreferrer">
                view
              </a>
            )}
            {t.status === "failed" && (
              <button
                onClick={async () => {
                  await api.retryTarget(id, t.id);
                  qc.invalidateQueries({ queryKey: ["post", id] });
                }}
              >
                Retry
              </button>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
